import { useEffect, useState } from 'react'

type Options = {
  themeColor?: string
}

export function useJivo({ themeColor }: Options = {}) {
  const [widgetLoaded, setWidgetLoaded] = useState(false)

  const setContactInfo = (info: {
    name?: string
    email?: string
    phone?: string
    description?: string
  }) => {
    if (widgetLoaded) {
      window.jivo_api.setContactInfo(info)
    }
  }

  const setCustomData = (
    data: Array<{ title?: string; content?: string; link?: string; key?: string }>,
  ) => {
    if (widgetLoaded) {
      window.jivo_api.setCustomData(data)
    }
  }

  useEffect(() => {
    // Можно подписаться на событие загрузки виджета
    window.jivo_onLoadCallback = () => {
      if (themeColor) {
        window.jivo_api.setWidgetColor(themeColor)
      }
      setWidgetLoaded(true)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    widgetLoaded,
    setContactInfo,
    setCustomData,
  }
}
